export default __webpack_public_path__ + "static/media/uploader-medtronic-3.29e56031.png";